module.exports = __webpack_public_path__ + "static/media/scatter_chart_icon.2ab1a862.svg";